import React, { Component } from 'react';
import AddArtwork from './AddArtwork';
import './Dashboard.css';

export default class Dashboard extends Component {
	render() {
		return(
			<AddArtwork base={this.props.base}/>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Dashboard.js